import Vue from "vue";

Vue.filter("secondsToString", function (seconds) {
	if (seconds > 0) {
		let hour = Math.floor(seconds / 3600),
			minute = Math.floor((seconds / 60) % 60);

		hour = hour < 10 ? "0" + hour : hour;
		minute = minute < 10 ? "0" + minute : minute;

		if (hour > 0 && minute > 0) return hour + "h " + minute + "m";
		if (hour > 0 && minute === "00") return hour + "h";
		return minute + "m";
	}
	return "";
});
